// extracted by mini-css-extract-plugin
module.exports = {"not-found-container":"not-found_not-found-container__z7tPa","not-found__title":"not-found_not-found__title__2jftp"};